import { Box, Paper, Typography } from "@mui/material";
import BrowseHandymanList from "./BrowseHandymanList";
import React from 'react';
import { connect } from 'react-redux';
import { HandymanAppState } from '../../configuration/redux/reducers';
import GoogleMapsWrapper from '../UserProfile/components/UserDetails/GoogleMapsWrapper';

interface StateFromProps {
  isLoading: boolean;
}

const BrowseHandymanPage = (props: StateFromProps) => {
  return (
    <Box
      sx={{
        background: 'linear-gradient(to bottom, #f5f5f5, #ffffff)',
        minHeight: '100vh',
        py: 10,
      }}
    >
      <Box
        width={{ xs: '90%', sm: '80%', md: '75%' }}
        mx="auto"
        mt={4}
        p={{ xs: 2, sm: 4 }}
        component={Paper}
        elevation={4}
        sx={{ borderRadius: 4 }}
      >
        <Typography variant="h4" gutterBottom textAlign="center">
          Browse Handyman
        </Typography>
        <GoogleMapsWrapper>
          <BrowseHandymanList
            actionButtonTitle="Create Order"
            onAction={() => null}
          />
        </GoogleMapsWrapper>
      </Box>
    </Box>
  );
}

const mapStateToProps = (state: HandymanAppState): StateFromProps => ({
  isLoading: state.handyman.isLoading
});

export default connect<StateFromProps, {}, {}, HandymanAppState>(
  mapStateToProps,
  {}
)(BrowseHandymanPage);